export { FunctionalArea } from './FunctionalArea.component';
